/**
 * 资产类别 API
 */
import Ajax from '../js/common/ajax';

export default {
	// 获取资产类别列表
	getAssetCategories() {
		return Ajax.get("/asset-categories")
	},
	// 获取单个资产类别
	getAssetCategory(id) {
		return Ajax.get(`/asset-categories/${id}`)
	},
	// 生成类别编码
	generateAssetCategoryCode() {
		return Ajax.get("/asset-categories/generate-code")
	},
	// 创建资产类别
	createAssetCategory(params = {}) {
		return Ajax.post("/asset-categories", params)
	},
	// 更新资产类别
	updateAssetCategory(id, params = {}) {
		return Ajax.put(`/asset-categories/${id}`, params)
	},
	// 删除资产类别
	deleteAssetCategory(id) {
		return Ajax.delete(`/asset-categories/${id}`)
	},
	// 初始化默认资产类别
	initDefaultAssetCategories() {
		return Ajax.post("/asset-categories/init-default")
	}
}
